import Vue from "vue";
import Vuex from "vuex";

import admissions from "./admissions.module";
import category from "./category.module";
import code from "./code.module";
import dashboard from "./dashboard.module";
import editingState from "./editingState.module";
import list from "./list.module";
import listFormat from "./listFormat.module";
import loading from "./loading.module";
import admissionSearch from "./admissionSearch.module";
import post from "./post.module";
import searchOptions from "./searchOptions.module";
import serverInfo from "./serverInfo.module";
import sort from "./sort.module";
import user from "./user.module"
import users from "./users.module";

Vue.use(Vuex);

export default new Vuex.Store({

	modules: {
		admissions,
		admissionSearch,
		category,
		code,
		dashboard,
		editingState,
		list,	
		listFormat,
		loading,
		post,
		searchOptions,
		serverInfo,
		sort,
		user,
		users
	}

});